window.addEventListener("popstate", () => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
});
